// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-doc-container {\n  box-sizing: border-box;\n  padding-left: 13.75rem;\n  overflow: hidden;\n}\n.van-doc-container--with-simulator {\n  padding-right: 24.375rem;\n}\n", ""]);
// Exports
module.exports = exports;
